import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const POST_PATIENT_MASTER_CRITERIA_API = `${API_URL}/api/PatientMasterMasteryCriteria/SavePatientMasterMasteryCriteria`;
export const GET_PATIENT_MASTER_CRITERIA_API = `${API_URL}/api/PatientMasterMasteryCriteria/GetPatientMasteryCriteriaByPatientId`;

export const masterCriteriaActionTypes = {
  get_masterData: createRequestActionTypes('GET_PATIENT_MASTER_CRITERIA_MASTER_DATA'),
  save_patientMasterCriteria: createRequestActionTypes('SAVE_PATIENT_MASTER_CRITERIA'),
  get_patientMasterCriteria: createRequestActionTypes('GET_PATIENT_MASTER_CRITERIADETAIL'),
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/masteryCriteria/constants/ApiConstants.js